import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

import BrandingContext from '../../Context/BrandingContext';

export const AssetAdvancedInfo = ({
  stwWiFiControl,
  stwWiFiEnabled,
  WiFissid,
  WiFipassword,
  handlePropUpdateSimple,
  visibility,
  vendor,
}) => {
  const { primary_alert } = useContext(BrandingContext);

  return (
    <div className={`${visibility} flex-grow-1 row text-muted`}>
      <div className="col-12">
        {vendor === '1' ? null : (
          <>
            <div className="form-group form-control-sm text-muted mb-2">
              <Switch
                onChange={(e) =>
                  handlePropUpdateSimple({
                    target: { name: 'stwWiFiControl', value: e },
                  })
                }
                checked={stwWiFiControl}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="stwWiFiControl-toggle"
              />
              <label
                htmlFor="stwWiFiControl-toggle"
                className="text-muted ml-2"
              >
                Enable STW Wi-Fi Control
              </label>
            </div>
            {stwWiFiControl ? (
              <>
                <div className="form-group form-control-sm text-muted mb-2">
                  <Switch
                    onChange={(e) =>
                      handlePropUpdateSimple({
                        target: { name: 'stwWiFiEnabled', value: e },
                      })
                    }
                    checked={stwWiFiEnabled}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    height={15}
                    width={30}
                    onColor={primary_alert}
                    id="stwWiFiEnabled-toggle"
                  />
                  <label
                    htmlFor="stwWiFiEnabled-toggle"
                    className="text-muted ml-2"
                  >
                    STW Wi-Fi On/Off
                  </label>
                </div>
                {stwWiFiEnabled ? (
                  <>
                    <div className="form-group text-muted">
                      <label htmlFor="WiFissid" className="three-quarter-text">
                        Wi-Fi Access Point SSID
                      </label>
                      <input
                        name="WiFissid"
                        type="text"
                        className={`form-control form-control-sm`}
                        onChange={handlePropUpdateSimple}
                        value={WiFissid}
                      />
                    </div>
                    <div className="form-group text-muted">
                      <label
                        htmlFor="WiFipassword"
                        className="three-quarter-text"
                      >
                        Wi-Fi Password
                      </label>
                      <input
                        name="WiFipassword"
                        type="text"
                        className={`form-control form-control-sm`}
                        onChange={handlePropUpdateSimple}
                        value={WiFipassword}
                      />
                    </div>
                  </>
                ) : null}
              </>
            ) : null}
          </>
        )}
      </div>
      <style jsx>{`
        .form-control:focus {
          box-shadow: none;
        }
        input {
          color: var(--black-text);
        }
        input::placeholder {
          color: var(--icon-link-gray);
          font-size: 0.9rem;
        }
        .template-select {
          margin-bottom: 10rem;
        }
      `}</style>
    </div>
  );
};

AssetAdvancedInfo.propTypes = {
  stwWiFiControl: PropTypes.bool,
  stwWiFiEnabled: PropTypes.bool,
  WiFissid: PropTypes.string,
  WiFipassword: PropTypes.string,
  handlePropUpdateSimple: PropTypes.func,
  visibility: PropTypes.string,
  vendor: PropTypes.string,
};

AssetAdvancedInfo.defaultProps = { handleTimezoneToggle: () => null };
